// extracted by mini-css-extract-plugin
export default {"willingness":"willingness_willingness__cjFCv","selected":"willingness_selected__Bdfwk","bottom":"willingness_bottom__FGrgn"};